"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const castNumberToCoordinate_1 = __importDefault(require("../../shared/castNumberToCoordinate"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const mapPolygonCheckIfCoordinatesAreInside_1 = __importDefault(require("../../shared/mapPolygonCheckIfCoordinatesAreInside"));
const callableIsCoordinateInsidePoligon = ({ entryVars: { latitude, longitude, polygon, }, functionId, callbacks, executeProcesses, }) => {
    const x = (0, castNumberToCoordinate_1.default)(latitude);
    const y = (0, castNumberToCoordinate_1.default)(longitude);
    if (!x || !y) {
        executeProcesses(functionId, callbacks.onError, 'Invalid search coordinates');
        return false;
    }
    if (!(0, valueIsRecord_1.default)(polygon)) {
        executeProcesses(functionId, callbacks.onError, 'Invalid polygon');
        return false;
    }
    const isInside = (0, mapPolygonCheckIfCoordinatesAreInside_1.default)({
        latitude: x,
        longitude: y,
        polygon,
    });
    if (isInside) {
        executeProcesses(undefined, callbacks.onInside);
    }
    else {
        executeProcesses(undefined, callbacks.onOutOf);
    }
    return isInside;
};
exports.default = callableIsCoordinateInsidePoligon;
